export default __webpack_public_path__ + "static/media/32_mobile.04337d41.jpg";